<div class="body-content">
    <div class="router-container" loading="Cargando...">
      <router-outlet></router-outlet>
    </div>
</div>